// Dictionnaire FR → ES pour l'interface (le vocabulaire comptable réglementaire
// français — FEC, PCG, HT/TTC/TVA, codes journaux — est conservé tel quel).
// Les clés doivent correspondre EXACTEMENT au texte français (après trim).

const MONTHS_ES = {
  janvier: "Enero", février: "Febrero", mars: "Marzo", avril: "Abril",
  mai: "Mayo", juin: "Junio", juillet: "Julio", août: "Agosto",
  septembre: "Septiembre", octobre: "Octubre", novembre: "Noviembre", décembre: "Diciembre",
};

const DAYS_ES = {
  lundi: "lunes", mardi: "martes", mercredi: "miércoles", jeudi: "jueves",
  vendredi: "viernes", samedi: "sábado", dimanche: "domingo",
};

// "mercredi 2 septembre 2026" → "miércoles 2 de septiembre de 2026"
function translateFrDate(s) {
  const m = s.match(/^(lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\s+(\d{1,2})(?:er)?\s+(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)(?:\s+(\d{4}))?$/i);
  if (!m) return null;
  const day = DAYS_ES[m[1].toLowerCase()];
  const month = (MONTHS_ES[m[3].toLowerCase()] || m[3]).toLowerCase();
  return `${day} ${m[2]} de ${month}${m[4] ? ` de ${m[4]}` : ""}`;
}

export const DICT = {
  // ===== Navigation / layout =====
  "Tableau de bord": "Panel de control",
  "Patients": "Pacientes",
  "Catalogue": "Catálogo",
  "Factures": "Facturas",
  "Paiements": "Pagos",
  "Rapprochement": "Conciliación",
  "Rendez-vous": "Citas",
  "Comptabilité": "Contabilidad",
  "Validations": "Validaciones",
  "Imports": "Importaciones",
  "Exports": "Exportaciones",
  "Audit": "Auditoría",
  "Paramètres": "Configuración",
  "Déconnexion": "Cerrar sesión",
  "Langue": "Idioma",
  "Administrateur": "Administrador",
  "Collaborateur": "Colaborador",
  "Ouvrir le menu": "Abrir el menú",
  "Fermer le menu": "Cerrar el menú",
  "Chargement…": "Cargando…",
  "Vérification…": "Verificando…",
  "EURL · privé": "EURL · privado",

  // ===== Login =====
  "Connexion": "Iniciar sesión",
  "Se connecter": "Iniciar sesión",
  "Se connecter avec Google": "Iniciar sesión con Google",
  "Connexion…": "Conectando…",
  "E-mail": "Correo electrónico",
  "Mot de passe": "Contraseña",
  "ou": "o",
  "Outil privé · accès restreint": "Herramienta privada · acceso restringido",
  "Identifiez-vous avec votre compte Google (administrateur) ou vos identifiants fournis par l'administrateur.": "Identifíquese con su cuenta de Google (administrador) o con las credenciales proporcionadas por el administrador.",
  "Si votre compte n'est pas autorisé, contactez l'administrateur pour être ajouté.": "Si su cuenta no está autorizada, contacte al administrador para ser añadido.",
  "Connexion refusée.": "Conexión rechazada.",
  "Échec de la connexion Google.": "Error al iniciar sesión con Google.",
  "E-mail ou mot de passe incorrect.": "Correo o contraseña incorrectos.",
  "Trop de tentatives. Réessayez dans 15 minutes.": "Demasiados intentos. Inténtelo de nuevo en 15 minutos.",
  "Compte désactivé. Contactez l'administrateur.": "Cuenta desactivada. Contacte al administrador.",

  // ===== Commun (boutons / actions) =====
  "Enregistrer": "Guardar",
  "Annuler": "Cancelar",
  "Supprimer": "Eliminar",
  "Modifier": "Modificar",
  "Éditer": "Editar",
  "Créer": "Crear",
  "Valider": "Validar",
  "Fermer": "Cerrar",
  "Retour": "Volver",
  "Rechercher": "Buscar",
  "Ajouter": "Añadir",
  "Télécharger": "Descargar",
  "Envoyer": "Enviar",
  "Confirmer": "Confirmar",
  "Ignorer": "Ignorar",
  "Sélectionner": "Seleccionar",
  "Tout sélectionner": "Seleccionar todo",
  "Tout déplier": "Desplegar todo",
  "Tout replier": "Plegar todo",
  "Actions": "Acciones",
  "Détails": "Detalles",
  "Aujourd'hui": "Hoy",
  "Jour précédent": "Día anterior",
  "Jour suivant": "Día siguiente",
  "Oui": "Sí",
  "Non": "No",
  "Erreur": "Error",
  "Aucun résultat": "Sin resultados",
  "Aucun résultat.": "Sin resultados.",
  "Configuration": "Configuración",
  "Traçabilité": "Trazabilidad",
  "Workflow": "Flujo de trabajo",
  "Erreur de chargement": "Error de carga",
  "Date": "Fecha",
  "Montant": "Importe",
  "Statut": "Estado",
  "Client": "Cliente",
  "Nom": "Nombre",
  "Prénom": "Nombre de pila",
  "Téléphone": "Teléfono",
  "Adresse": "Dirección",
  "Ville": "Ciudad",
  "Pays": "País",
  "Code postal": "Código postal",
  "Notes": "Notas",
  "Libellé": "Concepto",
  "Quantité": "Cantidad",
  "Total": "Total",
  "Année": "Año",
  "Mois": "Mes",
  "Période": "Período",
  "Compte": "Cuenta",
  "Journal": "Diario",
  "Pièce": "Justificante",
  "Débit": "Debe",
  "Crédit": "Haber",
  "Solde": "Saldo",
  "Écart": "Diferencia",
  "Banque": "Banco",
  "Référence": "Referencia",

  // ===== Statuts factures =====
  "Brouillon": "Borrador",
  "Validée": "Validada",
  "Envoyée": "Enviada",
  "Payée": "Pagada",
  "Annulée": "Anulada",
  "Annulé": "Anulado",
  "Avoir": "Abono",
  "Rapprochée": "Conciliada",
  "Ignorée": "Ignorada",
  "Supprimé": "Eliminado",
  "Supprimée": "Eliminada",
  "Lié": "Vinculado",
  "Délié": "Desvinculado",
  "Verrouillée": "Bloqueada",
  "Verrouillée (FEC)": "Bloqueada (FEC)",
  "Exercice clôturé": "Ejercicio cerrado",
  "Facture non modifiable": "Factura no modificable",

  // ===== Dashboard =====
  "Vue d'ensemble de votre journée et indicateurs clés.": "Resumen de su día e indicadores clave.",
  "CA encaissé ce mois": "Facturación cobrada este mes",
  "RDV aujourd'hui": "Citas de hoy",
  "Brouillons à valider": "Borradores por validar",
  "Encaissements": "Cobros",
  "Flux mensuels": "Flujos mensuales",
  "Mensuel": "Mensual",
  "Quotidien": "Diario",
  "Factures récentes": "Facturas recientes",
  "Vue journalière": "Vista diaria",
  "Sorties": "Salidas",

  // ===== Patients =====
  "Base patients": "Base de pacientes",
  "Nouveau patient": "Nuevo paciente",
  "Fiche patient": "Ficha del paciente",
  "Rechercher par nom, email, téléphone…": "Buscar por nombre, correo, teléfono…",
  "Nom, prénom ou email…": "Apellido, nombre o correo…",
  "Patient créé": "Paciente creado",
  "Patient mis à jour": "Paciente actualizado",
  "Patient modifié": "Paciente modificado",
  "Patient supprimé": "Paciente eliminado",
  "Patient fusionné": "Paciente fusionado",
  "Doublon potentiel détecté": "Posible duplicado detectado",
  "Email contact": "Correo de contacto",
  "Prénom Nom": "Nombre y apellido",

  // ===== Factures =====
  "Nouvelle facture": "Nueva factura",
  "N°, patient…": "N.º, paciente…",
  "N° ou libellé…": "N.º o concepto…",
  "N° facture, libellé tx…": "N.º factura, concepto…",
  "Rechercher une facture (n° ou nom)…": "Buscar una factura (n.º o nombre)…",
  "Rechercher (n°, client, montant…)": "Buscar (n.º, cliente, importe…)",
  "Rechercher (numéro ou libellé)…": "Buscar (número o concepto)…",
  "Avoir créé en brouillon": "Abono creado como borrador",
  "Erreur création facture": "Error al crear la factura",
  "PDF régénéré": "PDF regenerado",
  "Régénérer le PDF": "Regenerar el PDF",
  "E-mail envoyé": "Correo enviado",
  "Relance envoyée": "Recordatorio enviado",
  "Brouillon créé (aucun service Calendly mappé — saisissez la ligne)": "Borrador creado (ningún servicio Calendly asignado — introduzca la línea)",
  "Brouillon créé (aucun service mappé pour ce type d'événement)": "Borrador creado (ningún servicio asignado para este tipo de evento)",
  "Brouillon pré-rempli depuis le dernier rendez-vous Calendly": "Borrador rellenado desde la última cita de Calendly",
  "Brouillon pré-rempli depuis le mapping Calendly": "Borrador rellenado desde la asignación de Calendly",
  "Joindre une facture déjà émise dans l'app": "Adjuntar una factura ya emitida en la aplicación",
  "Ajouter une facture (n° ou nom du patient)…": "Añadir una factura (n.º o nombre del paciente)…",
  "Saisissez un n° de facture ou un nom de patient avant de lancer la recherche.": "Introduzca un n.º de factura o un nombre de paciente antes de buscar.",
  "Lié — facture marquée acquittée": "Vinculado — factura marcada como pagada",

  // ===== Paiements =====
  "Historique des paiements enregistrés (création manuelle ou via rapprochement bancaire).": "Historial de pagos registrados (creación manual o mediante conciliación bancaria).",
  "Tous les paiements de l'année avec leur facture associée.": "Todos los pagos del año con su factura asociada.",
  "Paiement enregistré": "Pago registrado",
  "Paiement supprimé": "Pago eliminado",
  "Supprimer ce paiement": "Eliminar este pago",
  "Aucun paiement": "Sin pagos",
  "Lier le paiement": "Vincular el pago",
  "Moyen de paiement": "Método de pago",

  // ===== Rapprochement =====
  "Rapprochement bancaire & paiements": "Conciliación bancaria y pagos",
  "Ensemble des transactions importées (Finom + Qonto) et leur état de rapprochement.": "Conjunto de transacciones importadas (Finom + Qonto) y su estado de conciliación.",
  "Banques": "Bancos",
  "Transaction supprimée.": "Transacción eliminada.",
  "Aucune facture liée à cette transaction.": "Ninguna factura vinculada a esta transacción.",
  "Attacher le PDF à la transaction Qonto": "Adjuntar el PDF a la transacción de Qonto",
  "PDF attaché à la transaction Qonto": "PDF adjuntado a la transacción de Qonto",
  "Justificatif envoyé à Qonto": "Justificante enviado a Qonto",
  "Envoyer ce justificatif à Qonto": "Enviar este justificante a Qonto",
  "Pas de justificatif": "Sin justificante",
  "Aucune transaction rapprochée sans justificatif.": "Ninguna transacción conciliada sin justificante.",
  "Type de transaction": "Tipo de transacción",

  // ===== Rendez-vous / Calendly =====
  "Rendez-vous Calendly": "Citas de Calendly",
  "Calendrier": "Calendario",
  "Calendly synchronisé": "Calendly sincronizado",
  "RDV à traiter": "Citas por tratar",
  "Aucun rendez-vous à traiter.": "Ninguna cita por tratar.",
  "Marquer comme non-honoré": "Marcar como no asistida",
  "RDV marqué comme non-honoré": "Cita marcada como no asistida",
  "RDV marqué comme non-honoré (lien forcé)": "Cita marcada como no asistida (vínculo forzado)",
  "RDV restauré": "Cita restaurada",
  "Restaurer le RDV": "Restaurar la cita",
  "Patient lié au rendez-vous": "Paciente vinculado a la cita",
  "Liez d'abord un patient à ce rendez-vous": "Vincule primero un paciente a esta cita",
  "Marquer comme non-honoré (le backend bloque si une facture validée est liée)": "Marcar como no asistida (bloqueado si hay una factura validada vinculada)",

  // ===== Comptabilité =====
  "Comptabilité (FEC)": "Contabilidad (FEC)",
  "Plan comptable, écritures, périodes et export FEC conforme à l'article L. 47 A I du LPF.": "Plan contable, asientos, períodos y exportación FEC conforme al artículo L. 47 A I del LPF (normativa francesa).",
  "Écritures": "Asientos",
  "Saisir une écriture": "Introducir un asiento",
  "Plan comptable": "Plan contable",
  "Livres comptables": "Libros contables",
  "Règles auto": "Reglas automáticas",
  "Caisse": "Caja",
  "Immobilisations": "Inmovilizado",
  "Clôture annuelle": "Cierre anual",
  "Comptes associés": "Cuentas de socios",
  "Séquence": "Secuencia",
  "Écriture supprimée": "Asiento eliminado",
  "Écriture modifiée. Solde recalculé.": "Asiento modificado. Saldo recalculado.",
  "Écriture archivée. Solde recalculé.": "Asiento archivado. Saldo recalculado.",
  "Écriture déséquilibrée — débits doivent égaler crédits.": "Asiento descuadrado — el debe debe igualar al haber.",
  "Modifier l'écriture": "Modificar el asiento",
  "Compte créé": "Cuenta creada",
  "Compte mis à jour": "Cuenta actualizada",
  "Compte supprimé": "Cuenta eliminada",
  "N° et libellé requis": "N.º y concepto requeridos",
  "N° compte exact": "N.º de cuenta exacto",
  "Libellé requis": "Concepto requerido",
  "Libellé requis.": "Concepto requerido.",
  "Libellé, pièce…": "Concepto, justificante…",
  "Toutes les lignes doivent avoir un compte.": "Todas las líneas deben tener una cuenta.",
  "Choisissez un compte PCG.": "Elija una cuenta del PCG.",
  "Choisissez une catégorie.": "Elija una categoría.",
  "Rechercher un compte (numéro, nom, mot-clé…)": "Buscar una cuenta (número, nombre, palabra clave…)",
  "Grand Livre": "Libro mayor",
  "Balance": "Balance de sumas y saldos",
  "Compte de résultat": "Cuenta de resultados",
  "Bilan": "Balance de situación",
  "Journaux": "Diarios",
  "Résultat de l'exercice": "Resultado del ejercicio",
  "Résultat d'exploitation": "Resultado de explotación",
  "Résultat financier": "Resultado financiero",
  "Résultat exceptionnel": "Resultado extraordinario",
  "Résultat courant avant impôt": "Resultado corriente antes de impuestos",
  "Total des charges d'exploitation": "Total de gastos de explotación",
  "Total des produits d'exploitation": "Total de ingresos de explotación",
  "Total des charges financières": "Total de gastos financieros",
  "Total des produits financiers": "Total de ingresos financieros",
  "Total des charges exceptionnelles": "Total de gastos extraordinarios",
  "Total des produits exceptionnels": "Total de ingresos extraordinarios",
  "Impôt sur les bénéfices": "Impuesto sobre beneficios",
  "Report à nouveau créditeur": "Remanente acreedor",
  "Report à nouveau débiteur": "Remanente deudor",
  "Réserves légales": "Reservas legales",
  "Réserves statutaires": "Reservas estatutarias",
  "Réserves réglementées": "Reservas reguladas",
  "Réserves facultatives": "Reservas voluntarias",
  "Réserves indisponibles": "Reservas indisponibles",
  "Prélèvements sur les réserves": "Retiradas de reservas",
  "Dividendes à payer": "Dividendos a pagar",
  "Mouvement de caisse comptabilisé.": "Movimiento de caja contabilizado.",
  "Mouvement supprimé.": "Movimiento eliminado.",
  "Mouvements": "Movimientos",
  "Opération enregistrée.": "Operación registrada.",
  "Règle enregistrée": "Regla guardada",
  "Immobilisation créée": "Inmovilizado creado",
  "Immobilisation mise à jour": "Inmovilizado actualizado",
  "Aucune immobilisation sélectionnée": "Ningún inmovilizado seleccionado",
  "Registre téléchargé": "Registro descargado",
  "Générer dotations": "Generar amortizaciones",
  "Générer": "Generar",
  "Générer l'AN": "Generar el asiento de apertura (AN)",
  "Durée > 0 mois requise": "Duración > 0 meses requerida",
  "Montant HT > 0 requis": "Importe HT > 0 requerido",
  "Montant invalide.": "Importe no válido.",
  "Date de cession requise": "Fecha de cesión requerida",
  "Date d'acquisition manquante ou plan non calculable": "Fecha de adquisición ausente o plan no calculable",
  "Céder ou mettre au rebut": "Ceder o dar de baja",
  "Contre-passer (OD)": "Contrapasar (OD)",
  "Contre-passation créée. L'originale est intacte.": "Contrapartida creada. La original queda intacta.",
  "Diviser en plusieurs comptes": "Dividir en varias cuentas",
  "Répartir sur plusieurs comptes": "Repartir entre varias cuentas",
  "Divisions enregistrées": "Divisiones guardadas",
  "Divisions supprimées": "Divisiones eliminadas",
  "Division": "División",
  "Annoter": "Anotar",
  "Catégoriser ou modifier la catégorie (compte + TVA)": "Categorizar o modificar la categoría (cuenta + IVA)",
  "Pas de catégo": "Sin categoría",
  "Pas d'écriture BQ": "Sin asiento BQ",
  "Ventilation et écriture supprimées — transaction en attente d'annotation": "Desglose y asiento eliminados — transacción pendiente de anotación",
  "Mouvements comptables 512x par origine": "Movimientos contables 512x por origen",
  "Ouverture et mouvements": "Apertura y movimientos",
  "Comparaison mois par mois": "Comparación mes a mes",
  "Trésorerie réelle (Qonto) :": "Tesorería real (Qonto):",
  "Cliquer pour voir les écritures qui composent ce solde": "Haga clic para ver los asientos que componen este saldo",
  "Aucun écart avec la balance Comptalib ✓": "Sin diferencias con el balance de Comptalib ✓",
  "Absent de Comptalib": "Ausente en Comptalib",
  "Absent de l'app": "Ausente en la aplicación",
  "Collez d'abord la balance Comptalib.": "Pegue primero el balance de Comptalib.",
  "Déjà en FEC": "Ya en el FEC",
  "Délier le FEC d'abord.": "Desvincule primero el FEC.",
  "Lien FEC supprimé.": "Vínculo FEC eliminado.",
  "Supprimer les écritures FEC": "Eliminar los asientos FEC",
  "Snapshot supprimé définitivement.": "Snapshot eliminado definitivamente.",
  "Purge annulée.": "Purga cancelada.",
  "Régénération annulée.": "Regeneración cancelada.",
  "La date de fin doit être postérieure à la date de début.": "La fecha de fin debe ser posterior a la fecha de inicio.",
  "Renseignez les dates de l'exercice exceptionnel.": "Indique las fechas del ejercicio excepcional.",
  "Sélectionnez au moins un exercice à fusionner.": "Seleccione al menos un ejercicio para fusionar.",
  "Sélectionnez l'exercice cible (qui sera conservé).": "Seleccione el ejercicio destino (que se conservará).",
  "Une reconstruction est déjà en cours — suivi de la progression…": "Ya hay una reconstrucción en curso — siguiendo el progreso…",
  "Séquence enregistrée": "Secuencia guardada",
  "Exercice exceptionnel 02/07/2024 → 31/12/2025": "Ejercicio excepcional 02/07/2024 → 31/12/2025",
  "Étape 1 · Reconstruire les lignes des factures Qonto": "Paso 1 · Reconstruir las líneas de las facturas Qonto",
  "Étape 2 · Régénérer les VE": "Paso 2 · Regenerar las VE",
  "Nouvelle opération ·": "Nueva operación ·",
  "Registre de caisse —": "Registro de caja —",

  // ===== Validations (approvals) =====
  "En attente": "En espera",
  "Approuvée": "Aprobada",
  "Rejetée": "Rechazada",
  "Échec à l'exécution": "Error en la ejecución",
  "Approuver": "Aprobar",
  "Rejeter": "Rechazar",
  "Historique": "Historial",
  "Détail technique": "Detalle técnico",
  "Aucune action en attente de validation.": "Ninguna acción pendiente de validación.",
  "Aucune demande traitée pour le moment.": "Ninguna solicitud tratada por el momento.",
  "Vos actions soumises à validation de l'administrateur.": "Sus acciones enviadas para validación del administrador.",
  "Actions préparées par le collaborateur, en attente de votre validation.": "Acciones preparadas por el colaborador, pendientes de su validación.",
  "Action soumise à validation de l'administrateur (onglet Validations).": "Acción enviada para validación del administrador (pestaña Validaciones).",
  "Action soumise à validation de l'administrateur.": "Acción enviada para validación del administrador.",
  "Action réservée à l'administrateur.": "Acción reservada al administrador.",
  "Action approuvée et exécutée.": "Acción aprobada y ejecutada.",
  "Demande rejetée.": "Solicitud rechazada.",
  "Demande annulée.": "Solicitud cancelada.",
  "Rejeter cette demande ?": "¿Rechazar esta solicitud?",
  "Motif du rejet (visible par le collaborateur)": "Motivo del rechazo (visible para el colaborador)",
  "Demandé par": "Solicitado por",
  "Traité par": "Tratado por",
  "Validation de facture": "Validación de factura",
  "Envoi de facture par e-mail": "Envío de factura por correo",
  "Création d'avoir": "Creación de abono",
  "Annulation de facture": "Anulación de factura",
  "Envoi de relance": "Envío de recordatorio",
  "Enregistrement de paiement": "Registro de pago",
  "Suppression de paiement": "Eliminación de pago",
  "Rapprochement bancaire": "Conciliación bancaria",
  "Rapprochement multi-factures": "Conciliación multifactura",
  "Annulation de rapprochement": "Anulación de conciliación",
  "Ignorer une transaction": "Ignorar una transacción",
  "Création d'écriture comptable": "Creación de asiento contable",
  "Modification d'écriture comptable": "Modificación de asiento contable",
  "Suppression d'écriture comptable": "Eliminación de asiento contable",
  "Catégorisation de transaction": "Categorización de transacción",
  "Catégorisation en masse": "Categorización masiva",
  "Suppression de catégorisation": "Eliminación de categorización",
  "Mouvement de caisse": "Movimiento de caja",
  "Suppression de mouvement de caisse": "Eliminación de movimiento de caja",
  "Liaison paiement Stripe": "Vinculación de pago Stripe",
  "Déliaison paiement Stripe": "Desvinculación de pago Stripe",
  "Liaison paiement Zettle": "Vinculación de pago Zettle",
  "Déliaison paiement Zettle": "Desvinculación de pago Zettle",

  // ===== Imports / Exports =====
  "Import terminé": "Importación finalizada",
  "Sync terminée": "Sincronización finalizada",
  "Factures (CSV)": "Facturas (CSV)",
  "Paiements (CSV)": "Pagos (CSV)",
  "Transactions bancaires (CSV)": "Transacciones bancarias (CSV)",
  "Transactions bancaires Finom (CSV)": "Transacciones bancarias Finom (CSV)",
  "Transactions bancaires Qonto (CSV)": "Transacciones bancarias Qonto (CSV)",
  "Factures Qonto (CSV — fallback)": "Facturas Qonto (CSV — alternativa)",
  "Factures Qonto (via API)": "Facturas Qonto (vía API)",
  "Archive annuelle (ZIP)": "Archivo anual (ZIP)",
  "Exports comptables": "Exportaciones contables",
  "Exports CSV (BOM UTF-8 compatibles Excel) et archive ZIP annuelle (CSV + PDFs).": "Exportaciones CSV (BOM UTF-8 compatibles con Excel) y archivo ZIP anual (CSV + PDFs).",
  "CSV + tous les PDFs de l'année. Idéal pour archivage et envoi au comptable.": "CSV + todos los PDFs del año. Ideal para archivar y enviar al contable.",
  "Ventes : N° facture, date, patient, HT, TVA, TTC, statut, paiement, banque, référence.": "Ventas: n.º de factura, fecha, paciente, HT, TVA, TTC, estado, pago, banco, referencia.",
  "Format CSV uniquement. Pour PDF/TXT, ouvrez dans Excel et exportez en CSV.": "Solo formato CSV. Para PDF/TXT, abra en Excel y exporte a CSV.",
  "Télécharger CSV": "Descargar CSV",
  "Télécharger XML (PPF)": "Descargar XML (PPF)",
  "Données externes": "Datos externos",
  "Récupération des justificatifs Qonto démarrée…": "Recuperación de justificantes de Qonto iniciada…",
  "Envoi des factures rapprochées vers Qonto démarré…": "Envío de facturas conciliadas hacia Qonto iniciado…",
  "Factures → Qonto : rien à envoyer, tout est déjà attaché.": "Facturas → Qonto: nada que enviar, todo ya está adjuntado.",
  "Rattachement des factures rapprochées comme justificatifs…": "Adjuntando las facturas conciliadas como justificantes…",

  // ===== E-reporting / Audit =====
  "E-reporting B2C": "E-reporting B2C",
  "Conformité DGFiP": "Conformidad DGFiP",
  "Journal d'audit": "Registro de auditoría",
  "Marquer comme transmis": "Marcar como transmitido",
  "Marqué comme transmis": "Marcado como transmitido",

  // ===== Paramètres =====
  "Société": "Empresa",
  "Identité": "Identidad",
  "Utilisateurs": "Usuarios",
  "Utilisateur créé": "Usuario creado",
  "Utilisateur mis à jour": "Usuario actualizado",
  "Utilisateur supprimé": "Usuario eliminado",
  "Ajouter un utilisateur": "Añadir un usuario",
  "Nouvel utilisateur": "Nuevo usuario",
  "Modifier l'utilisateur": "Modificar el usuario",
  "Rôle": "Rol",
  "Langue de l'interface": "Idioma de la interfaz",
  "Français": "Francés",
  "Español": "Español",
  "Collaborateur (validation requise)": "Colaborador (validación requerida)",
  "Compte actif": "Cuenta activa",
  "Compte désactivé": "Cuenta desactivada",
  "Actif": "Activa",
  "Désactivé": "Desactivada",
  "Jamais": "Nunca",
  "Dernière connexion": "Última conexión",
  "Créer le compte": "Crear la cuenta",
  "Mot de passe (min. 8 caractères)": "Contraseña (mín. 8 caracteres)",
  "Nouveau mot de passe (laisser vide pour ne pas changer)": "Nueva contraseña (dejar vacío para no cambiar)",
  "Les collaborateurs se connectent par e-mail / mot de passe. Leurs actions sensibles": "Los colaboradores inician sesión con correo / contraseña. Sus acciones sensibles",
  "(factures, écritures, rapprochements) passent par l'onglet": "(facturas, asientos, conciliaciones) pasan por la pestaña",
  "Cette page est réservée à l'administrateur.": "Esta página está reservada al administrador.",
  "Informations de votre EURL, modèle de numérotation, SMTP, et clés d'API externes.": "Información de su EURL, modelo de numeración, SMTP y claves de API externas.",
  "Paramètres enregistrés": "Configuración guardada",
  "Nom (raison sociale)": "Nombre (razón social)",
  "Nom commercial / Cabinet": "Nombre comercial / Consulta",
  "Forme juridique": "Forma jurídica",
  "Site web": "Sitio web",
  "E-mail de test envoyé": "Correo de prueba enviado",
  "Indiquez un destinataire": "Indique un destinatario",
  "Serveur SMTP": "Servidor SMTP",
  "Identifiant SMTP": "Usuario SMTP",
  "Mot de passe SMTP": "Contraseña SMTP",
  "Nom expéditeur": "Nombre del remitente",
  "E-mail expéditeur": "Correo del remitente",
  "Délai de paiement (jours)": "Plazo de pago (días)",
  "Préfixe numéro (ex: F-)": "Prefijo del número (ej.: F-)",
  "Taux TVA par défaut (%)": "Tipo de TVA (IVA francés) por defecto (%)",
  "Mention légale ligne par défaut": "Mención legal por defecto",
  "Logo (en haut à droite du PDF)": "Logotipo (arriba a la derecha del PDF)",
  "Cachet / signature (apposé sur la mention « Facture acquittée »)": "Sello / firma (sobre la mención « Facture acquittée »)",
  "Image enregistrée": "Imagen guardada",
  "Mapping enregistré": "Asignación guardada",
  "Catalogue de services": "Catálogo de servicios",
  "Service créé": "Servicio creado",
  "Service mis à jour": "Servicio actualizado",
  "Prestations": "Prestaciones",
  "Services": "Servicios",
  "Prix de vente invalide": "Precio de venta no válido",
  "Nom requis": "Nombre requerido",
  "Nom et compte requis": "Nombre y cuenta requeridos",
  "Note interne (libre)": "Nota interna (libre)",
  "Commentaire enregistré.": "Comentario guardado.",
  "Commentaire présent": "Comentario presente",
  "Maintenance des données": "Mantenimiento de datos",
  "Heure (0-23, Europe/Paris)": "Hora (0-23, Europa/París)",
  "Minute (0-59)": "Minuto (0-59)",
  "Automatisation": "Automatización",

  // ===== Associés =====
  "Associé créé.": "Socio creado.",
  "Associé mis à jour.": "Socio actualizado.",
  "Associé supprimé.": "Socio eliminado.",

  // ===== Divers / erreurs génériques =====
  "Au moins un motif (libellé ou contrepartie) requis": "Se requiere al menos un criterio (concepto o contraparte)",
  "Aucun nouveau compte 455 à découvrir. Tous sont déjà configurés.": "Ninguna cuenta 455 nueva por descubrir. Todas ya están configuradas.",
  "Toutes les transactions ont déjà un sens (entrée/sortie) défini.": "Todas las transacciones ya tienen un sentido (entrada/salida) definido.",
  "Erreur enregistrement": "Error al guardar",
  "Backfill : timeout (>10 min). Vérifiez les logs.": "Backfill: tiempo de espera agotado (>10 min). Revise los registros.",
  "Sync : timeout (>10 min).": "Sincronización: tiempo agotado (>10 min).",
  "Rattachement : timeout (>10 min).": "Adjunto: tiempo agotado (>10 min).",
  "Récupération : timeout (>15 min).": "Recuperación: tiempo agotado (>15 min).",
  "Envoi vers Qonto : timeout (>15 min).": "Envío hacia Qonto: tiempo agotado (>15 min).",
  "Webhook Calendly abonné. La clé de signature est enregistrée.": "Webhook de Calendly suscrito. La clave de firma está guardada.",
  "Sur les encaissements": "Sobre los cobros",
  "Conditions de paiement de la TVA": "Condiciones de pago de la TVA (IVA francés)",
  "auto-rempli": "autocompletado",
  "dont écart d'ouverture": "de los cuales diferencia de apertura",
  "dont écart de mouvements": "de los cuales diferencia de movimientos",

  // ===== Fragments dynamiques (nœuds texte adjacents à des variables) =====
  "En attente (": "En espera (",
  "Clôturé (": "Cerrado (",
  "Déséquilibré (": "Descuadrado (",
  "Supprimer (": "Eliminar (",
  "Snapshots disponibles (": "Snapshots disponibles (",
  "Écritures AN existantes (": "Asientos AN existentes (",
  "Solde comptable 512x (": "Saldo contable 512x (",
  "Solde d'ouverture au 01/01/": "Saldo de apertura a 01/01/",
  "Afficher non-honorés (": "Mostrar no asistidas (",
  "Afficher RDV verrouillés (≤": "Mostrar citas bloqueadas (≤",
  "Déjà comptabilisée via FEC (": "Ya contabilizada vía FEC (",
  "Plafond 10 % capital (": "Límite 10 % del capital (",
  "Σ sélection (": "Σ selección (",
  "✓ Aucun écart (": "✓ Sin diferencias (",
  "⚠ Sans ID Qonto :": "⚠ Sin ID de Qonto:",
  "📊 Diagnostic Qonto (depuis": "📊 Diagnóstico Qonto (desde",
  "Sans catégorisation :": "Sin categorización:",
  "Sans justificatif :": "Sin justificante:",
  "Sans écriture :": "Sin asiento:",
  "Depuis :": "Desde:",
  "Période :": "Período:",
  "Date de": "Fecha de",
  "Détail des": "Detalle de",
  "Écart de": "Diferencia de",
  "Régénération BQ :": "Regeneración BQ:",
  "Résultat : app": "Resultado: app",
  "Séquence mise à jour : année": "Secuencia actualizada: año",
  "Variables disponibles :": "Variables disponibles:",
  "Variables:": "Variables:",
  "actif(s)": "activo(s)",
  "autres": "otros",
  "comptes)": "cuentas)",
  "couvertes par un exercice clôturé (ignorées)": "cubiertas por un ejercicio cerrado (ignoradas)",
  "division(s) purgée(s).": "división(es) purgada(s).",
  "divisions configurées": "divisiones configuradas",
  "ignorée(s) (rapprochées)": "ignorada(s) (conciliadas)",
  "jour": "día",
  "journaux": "diarios",
  "lettrage(s) effacé(s)": "punteo(s) borrado(s)",
  "lignes": "líneas",
  "mois": "meses",
  "pages Qonto": "páginas Qonto",
  "probable(s)": "probable(s)",
  "rapprochement(s) re-pointé(s)": "conciliación(es) revisada(s)",
  "recréée(s)": "recreada(s)",
  "supprime toutes les VE de": "elimina todas las VE de",
  "supprimée(s)": "eliminada(s)",
  "transaction(s)": "transacción(es)",
  "à une facture": "a una factura",
  "échec(s) :": "fallo(s):",
  "écritures": "asientos",
  "Σ Crédit :": "Σ Haber:",
  "Σ Débit :": "Σ Debe:",
  "— Statut :": "— Estado:",
  "— ajustez la répartition": "— ajuste el reparto",
  "Générer les dotations": "Generar las amortizaciones",
  "Registre PDF": "Registro PDF",
  "(vous)": "(usted)",
  "facture": "factura",
  "factures": "facturas",
  "non comptabilisée": "no contabilizada",
  "non comptabilisées": "no contabilizadas",
  "transaction pour annoter": "transacción por anotar",
  "transactions pour annoter": "transacciones por anotar",
  "transaction à annoter": "transacción por anotar",
  "transactions à annoter": "transacciones por anotar",
  "Envoi…": "Enviando…",
  "Purge…": "Purgando…",
  "Génération…": "Generando…",
  "Analyse…": "Analizando…",
  "Scan…": "Escaneando…",
  "Sync…": "Sincronizando…",
  "Débits": "Debe",
  "Crédits": "Haber",
  "Du": "Del",
  "Au": "Al",
  "Fin": "Fin",
  "Début": "Inicio",
  "Relances auto": "Recordatorios auto",
  "Purger FEC": "Purgar FEC",
  "Générer BQ": "Generar BQ",
  "Recalculer": "Recalcular",
  "Reconstruire": "Reconstruir",
  "Aucune en attente.": "Ninguna en espera.",
  "À revoir avant clôture d'exercice.": "Por revisar antes del cierre del ejercicio.",
  "Facture (brouillon)": "Factura (borrador)",
  "(brouillon)": "(borrador)",

  // ===== Graphiques / dashboard (compléments) =====
  "Revenu mensuel (historique complet)": "Ingresos mensuales (historial completo)",
  "Entrées (CA HT)": "Entradas (CA HT)",
  "Sorties (dépenses réelles)": "Salidas (gastos reales)",
  "Trésorerie": "Tesorería",
  "Entrées": "Entradas",
  "Créée le": "Creada el",
  "TVA %": "TVA %",
  "Jan": "Ene", "Fév": "Feb", "Avr": "Abr", "Mai": "May", "Juin": "Jun",
  "Juil": "Jul", "Aoû": "Ago", "Déc": "Dic",

  "Type de RDV": "Tipo de cita",
  "Prix": "Precio",
  "Non-honoré": "No asistida",
  "Non-honorés": "No asistidas",
  "À lier": "Por vincular",
  "brouillon": "borrador",
  "Facturé ailleurs": "Facturado en otra fecha",

  // ===== Assistant CA3 =====
  "Assistant CA3 — Déclaration de TVA": "Asistente CA3 — Declaración de TVA (IVA francés)",
  "Pré-remplissage du formulaire 3310-CA3 à partir des écritures comptabilisées (comptes 4452xx / 4456xx / 4457xx).": "Prellenado del formulario 3310-CA3 a partir de los asientos contabilizados (cuentas 4452xx / 4456xx / 4457xx).",
  "TVA (CA3)": "TVA (CA3)",
  "Trimestre": "Trimestre",
  "TVA brute due (16)": "TVA bruta debida (16)",
  "TVA déductible (23)": "TVA deducible (23)",
  "TVA nette due (28)": "TVA neta debida (28)",
  "Crédit de TVA (25)": "Crédito de TVA (25)",
  "A — Montant des opérations réalisées (bases HT)": "A — Importe de las operaciones realizadas (bases HT)",
  "B — TVA brute / C — TVA déductible": "B — TVA bruta / C — TVA deducible",
  "Ligne": "Línea",
  "Base HT": "Base HT",
  "Ventes, prestations de services (France, taxables)": "Ventas, prestaciones de servicios (Francia, gravadas)",
  "Achats de prestations de services intracommunautaires (art. 283-2)": "Compras de servicios intracomunitarios (art. 283-2)",
  "Achats auprès d'un assujetti non établi en France (art. 283-1)": "Compras a un sujeto pasivo no establecido en Francia (art. 283-1)",
  "Importations de biens (données douane)": "Importaciones de bienes (datos de aduana)",
  "Autres opérations non imposables (ventes exonérées art. 261)": "Otras operaciones no imponibles (ventas exentas art. 261)",
  "Livraisons intracommunautaires": "Entregas intracomunitarias",
  "Taux normal 20 %": "Tipo normal 20 %",
  "Total de la TVA brute due": "Total de la TVA bruta debida",
  "Dont TVA sur acquisitions intracommunautaires (biens)": "De la cual TVA sobre adquisiciones intracomunitarias (bienes)",
  "TVA déductible sur immobilisations": "TVA deducible sobre inmovilizado",
  "TVA déductible sur biens et services": "TVA deducible sobre bienes y servicios",
  "Total de la TVA déductible": "Total de la TVA deducible",
  "Crédit de TVA": "Crédito de TVA",
  "TVA nette due": "TVA neta debida",
  "Détail des comptes TVA et produits": "Detalle de las cuentas de TVA e ingresos",
  "Aucun compte TVA/produit mouvementé sur la période.": "Ninguna cuenta de TVA/ingresos con movimientos en el período.",
  "écritures analysées sur la période": "asientos analizados en el período",
  "CA comptabilisé (70x) :": "Facturación contabilizada (70x):",
  "Erreur de calcul CA3": "Error de cálculo CA3",
  "Ventes du cabinet exonérées de TVA (art. 261) → reportées en ligne E2.": "Ventas de la consulta exentas de TVA (art. 261) → declaradas en la línea E2.",
  "Achats UE (zone intracom) traités comme prestations de services → base en A3, TVA autoliquidée en ligne 08 et déduite en ligne 20 (opération neutre).": "Compras UE (zona intracomunitaria) tratadas como servicios → base en A3, TVA autoliquidada en línea 08 y deducida en línea 20 (operación neutra).",
  "Achats hors UE traités comme services d'un assujetti non établi (art. 283-1) → ligne B2. Pour des importations de biens, reportez la base douane en ligne B4.": "Compras fuera de la UE tratadas como servicios de un sujeto no establecido (art. 283-1) → línea B2. Para importaciones de bienes, indique la base de aduana en la línea B4.",
  "Montants à reporter arrondis à l'euro le plus proche sur le formulaire 3310-CA3.": "Importes a declarar redondeados al euro más próximo en el formulario 3310-CA3.",

  // ===== Dialogues de confirmation =====
  "Confirmation": "Confirmación",
  "Valider la facture ? Un numéro définitif sera attribué et le PDF généré. Cette action est irréversible.": "¿Validar la factura? Se asignará un número definitivo y se generará el PDF. Esta acción es irreversible.",
  "Annuler/Supprimer cette facture ?": "¿Anular/eliminar esta factura?",
  "Envoyer une relance par e-mail au patient ?": "¿Enviar un recordatorio por correo al paciente?",
};

export const PATTERNS = [
  { re: /^(\d+)\s+RDV$/, out: (m) => `${m[1]} citas` },
  { re: /^(\d+)\s+à traiter$/, out: (m) => `${m[1]} por tratar` },
  { re: /^(\d+)\s+facture(s)?$/, out: (m) => `${m[1]} factura${m[2] ? "s" : ""}` },
  { re: /^(\d+)\s+patient(s)?$/, out: (m) => `${m[1]} paciente${m[2] ? "s" : ""}` },
  { re: /^(\d+)\s+écriture(s)?$/, out: (m) => `${m[1]} asiento${m[2] ? "s" : ""}` },
  { re: /^(\d+)\s+transaction(s)?$/, out: (m) => `${m[1]} transacci${m[2] ? "ones" : "ón"}` },
  { re: /^(\d+)\s+résultat(s)?$/, out: (m) => `${m[1]} resultado${m[2] ? "s" : ""}` },
  { re: /^Année\s+(\d{4})$/i, out: (m) => `Año ${m[1]}` },
  { re: /^Facture ((?:F-|A-|AV-).*)$/, out: (m) => `Factura ${m[1]}` },
  { re: /^Rendez-vous du (.+)$/, out: (m) => `Citas del ${translateFrDate(m[1]) || m[1]}` },
  { re: /^(lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\s.+$/i, out: (m) => translateFrDate(m[0]) || m[0] },
  {
    re: /^Supprimer le compte de (.+) \? Ses sessions seront révoquées immédiatement\. Cette action est irréversible\.$/,
    out: (m) => `¿Eliminar la cuenta de ${m[1]}? Sus sesiones se revocarán inmediatamente. Esta acción es irreversible.`,
  },
  {
    re: /^(Janvier|Février|Mars|Avril|Mai|Juin|Juillet|Août|Septembre|Octobre|Novembre|Décembre)\s+(\d{4})$/i,
    out: (m) => `${MONTHS_ES[m[1].toLowerCase()] || m[1]} ${m[2]}`,
  },
  { re: /^Demandé par$/, out: () => "Solicitado por" },
  { re: /^Traité par$/, out: () => "Tratado por" },
  { re: /^Page (\d+) sur (\d+)$/, out: (m) => `Página ${m[1]} de ${m[2]}` },
];
